'use client';

export function useLenis() {
  const scrollTo = (target: string | HTMLElement, options?: any) => {
    if (typeof window !== 'undefined') {
      const lenis = (window as any).globalLenis;
      if (lenis && typeof lenis.scrollTo === 'function') {
        lenis.scrollTo(target, options);
      } else {
        if (typeof target === 'string') {
          const element = document.querySelector(target);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
          }
        } else if (target instanceof HTMLElement) {
          target.scrollIntoView({ behavior: 'smooth' });
        }
      }
    }
  };
  return { scrollTo };
}
